import React, { Fragment } from 'react';
import BarLine from '../common/graphs/barLineNew';
import Constants from '../../containers/function/constants.js';

const TopCharts = (props) => {
  const { typeTab } = props;
  const { taskManagerTabs  } = Constants;
  let showBarLine = props.datos && props.datos.distribution;
  let showTotalTasks = false;
  let showTotalNotifications = false;
  let showTotalGlobal = false;

  switch (typeTab) {
    case taskManagerTabs.TAB_TASKS:
      showTotalTasks = true;
      break;
    case taskManagerTabs.TAB_NOTIFICATIONS:
      showBarLine = false;
      showTotalNotifications = true;
      break;
  }

  return (
    <section className="top top-charts" style={{...props.containerStyle}}>
      <div className={`bar-chart-legend-wrapper fix-bad-tour-position fix-bottom tour-top-charts__${typeTab.toLowerCase()}`}>
        {
          showBarLine && (
            <Fragment>
              <div className="chart-element bar-chart main_summary_graph__color">
                <label className="bar-chart-label">
                  {props.language.tasks_manager.topCharts.tasksByState}
                </label>
                <a className="normal" data-tags={false}>
                  <BarLine
                    name="key"
                    value="quantity"
                    distribution={props.datos.distribution}
                    language={props.language.tasks_manager.states}
                  />
                </a>
              </div>
              <div className="chart-element bar-chart-legend">
                {props.datos.distribution.map((item, i) => {
                  return (
                    <div key={`top-chart-${i}`} className="bar-chart-legend-item">
                      <div 
                        className="bar-chart-legend-item-color"
                        style={{
                          backgroundColor: Constants.taskManagerStateColorRange[item.key.toUpperCase()]
                        }}
                      />
                      <div className="bar-chart-legend-item-text">
                        {
                          `${props.language.tasks_manager.states[item.key.toUpperCase()]} (${item.percentage}% | ${item.quantity})` +
                          ((item.quantityDeviations) ? ` / ${props.language.tasks_manager.topCharts.notifications} (${item.quantityDeviations})`: '')
                        }
                      </div>
                    </div>
                  );
                })}
              </div>
            </Fragment>
          )
        }
      </div>

      <div className="chart-element summary-tasks">
        {
          showTotalTasks && (
            <div className="total-tasks total-tasks-total">
              {props.language.tasks_manager.topCharts.manageTasks + ": "}
              {props.datos && props.datos.taskQuantity ? props.datos.taskQuantity : 0}
            </div>
          )
        }
        {
          showTotalNotifications && (
            <div className="total-tasks total-tasks-notifications">
              {props.language.tasks_manager.topCharts.notifications + ": "}
              {props.datos && props.datos.notificationQuantity ? props.datos.notificationQuantity : 0}
            </div>
          )
        }
        {
          showTotalGlobal && (
            <div className="total-tasks">
              {props.language.tasks_manager.topCharts.totalTasks + ": "}
              {props.datos && props.datos.totalQuantity ? props.datos.totalQuantity : 0}
            </div>
          )
        }
      </div>
    </section>
  )
};

export default TopCharts;



// WEBPACK FOOTER //
// ./source/client/components/tasks_manager/topCharts.jsx